import { ChangePassComponent } from './changepassword/changepassword.component';
import { AuthenticationService } from './../../services/authentication.service';
import { Component, OnInit, ElementRef, ViewChild, Renderer2 } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { StorageService} from '../../services/storage.service';
import { Router, ActivatedRoute, Params} from '@angular/router';
import { User} from '../../models/user';
import { ENPOINT } from '../../services/endpoint';
import { JSONP_ERR_NO_CALLBACK } from '@angular/common/http/src/jsonp';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  providers: [AuthenticationService]
})
export class HomeComponent implements OnInit {
  public user: User;
  title = 'app';
  isParaActive = true;
  isBtnActive = true;

  rol;
  permisos;
  permiso;
  p;
  verModulosProveedor = false;
  verModulosAdmin = false;
  verFinancieras = false;
  verLogistica = false;
  verRevision = false;
  verComplementos = false;
  verFacturas = false;
  verEstadoCuenta = false;
  verManuales = false;
  verAlmacen = false;
  verServicios = false;
  verPreAlmacen = false;
  verComplementosPais: boolean;

  isAdmin: boolean = false;

  complementosProveedor;
  len = ENPOINT.len;

  closeResult;
  modal;

  constructor(
    private authenticationService: AuthenticationService,
    private modalService: NgbModal,
    private _router: Router,
    private storageService: StorageService,
    private renderer: Renderer2,
  ) { }

  ngOnInit() {
    this.noBack();
    this.user = this.storageService.getCurrentUser();
    // console.log(this.user);
    this.mostrarModulo();
    this.isParaActive = !this.isParaActive;
  }

  ngAfterViewInit() {
    setTimeout(() => this.primerInicioSesion());
  }

  noBack() {
  history.pushState(null, null, location.href);
    window.onpopstate = function () {
        history.go(1);
    };
  }

  primerInicioSesion() {

    if (this.user.pv == true) {
       this.modalService.open(ChangePassComponent, { centered: true, keyboard: false, backdrop: 'static' });
    }
    
  }

  toggleColor() {
    const x = document.getElementById('sidebar').style.width;
    // console.log(x);
  }

  toggleClass() {
    this.isParaActive = !this.isParaActive;
    this.isBtnActive = !this.isBtnActive;
    this.toggleColor();
  }

  mostrarModulo() {
    this.rol = this.user.rol
    if(this.user.rol == 1){
      this.isAdmin = true;
    }else{
      this.isAdmin = false;
    }
    //console.log(this.rol);-------------

    this.permisos = this.user.permisos;
    if (this.rol === 3) {
      this.verModulosProveedor = true;
      if (this.user.pais == "MX") {
        this.verComplementosPais = true;
      } else {
        this.verComplementosPais = false;
      }
    } else if (this.rol === 1) {
      this.verModulosAdmin = true;
    } else if (this.rol === 2) {
      if (this.permisos !== undefined) {
        if (this.permisos.length !== undefined && this.permisos.length > 0) {
          for (let i = 0; i < this.permisos.length; i++) {
            this.permiso = this.permisos[i].id;

            // console.log(this.permiso);
            if (this.permiso === 1) {
              this.verFinancieras = true;
            }
            if (this.permiso === 2) {
              this.verLogistica = true;
            }
            if (this.permiso === 3) {
              this.verRevision = true;
            }
            if (this.permiso === 4) {
              this.verComplementos = true;
            }
            if (this.permiso === 5) {
              this.verFacturas = true;
            }
            if (this.permiso === 6) {
              this.verEstadoCuenta = true;
            }
            if (this.permiso === 7) {
              this.verModulosAdmin = true;
            }
            if (this.permiso === 8) {
              this.verManuales = true;
            }
            if (this.permiso === 9) {
              this.verAlmacen = true;
            }
            if (this.permiso === 10) {
              this.verServicios = true;
            }
            if (this.permiso === 11) {
              this.verPreAlmacen = true;
            }
          }
        } else {
          this.p = this.permisos.id;
          // console.log(this.p);
          if (this.p === 1) {
            this.verFinancieras = true;
          }
          if (this.p === 2) {
            this.verLogistica = true;
          }
          if (this.p === 3) {
            this.verRevision = true;
          }
          if (this.p === 4) {
            this.verComplementos = true;
          }
          if (this.p === 5) {
            this.verFacturas = true;
          }
          if (this.p === 6) {
            this.verEstadoCuenta = true;
          }
          if (this.p === 7) {
            this.verModulosAdmin = true;
          }
          if (this.p === 8) {
            this.verManuales = true;
          }
          if (this.p === 9) {
            this.verAlmacen = true;
          }
          if (this.p === 10) {
            this.verServicios = true;
          }
          if (this.p === 11) {
            this.verPreAlmacen = true;
          }
        }
      }
    }

  }


  logOut() {
    this.authenticationService.cerrarSesion().subscribe(
      data => {
        this.storageService.removeCurrentSession();
        this._router.navigate(['/login']);
      },
      err => {
       
        this.storageService.removeCurrentSession();
        this._router.navigate(['/login']);
        
      },
    );
  }

  openChangePassword(content) {
    this.modal = this.modalService.open(ChangePassComponent, { centered: true, keyboard: false, backdrop: 'static' });
    this.modal.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReasonFiltersOC(reason)}`;
    });
  }

  private getDismissReasonFiltersOC(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

  
}



// WEBPACK FOOTER //
// ./src/app/pages/home/home.component.ts